import React from "react";
import { inject, observer } from "mobx-react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import PreviewPage from "../../pages/PreviewPage/PreviewPage";

@inject("navigationStore", "previewStore", "detailViewStore", "popupStore")
@observer
export class NavigationTabs extends React.Component {
  componentDidMount() {
    const { popupStore } = this.props;
    popupStore.setcloseButton(true);
  }
  componentWillUnmount() {
    const { popupStore } = this.props;
    popupStore.setcloseButton(false);
  }
  render() {
    const { navigationTabs, tabIndex, setTabIndex } =
      this.props.navigationStore;
    const { setType, setTid, setCanRefresh } = this.props.popupStore;
    const tabs = [];
    const tabPanels = [];

    navigationTabs.forEach((item, index) => {
      if (item.tid) {
        tabs.push(
          <Tab
            key={`${item.tid}-tab`}
            onClick={(e) => {
              e.preventDefault();
              setCanRefresh(true);
              setType(item.type);
              setTid(item.tid);
            }}
          >
            {item?.datas?.item?.object?.name}
          </Tab>
        );

        tabPanels.push(
          <TabPanel forceRender={true} key={`${item.tid}-tabpanel`}>
            <PreviewPage></PreviewPage>
          </TabPanel>
        );
      }
    });

    return (
      <div style={{ display: "flex", width: "100%" }}>
        {tabs.length > 0 ? (
          <Tabs>
            <Tabs
              forceRenderTabPanel={true}
              selectedIndex={tabIndex}
              onSelect={(selectedIndex) => setTabIndex(selectedIndex)}
            >
              <TabList>{tabs}</TabList>
              {tabPanels}
            </Tabs>
          </Tabs>
        ) : 
          //this version of react-tabs won't load if array is empty, without it, previewPage won't load on first click
          <PreviewPage display={false}></PreviewPage>
        }

      </div>
    );
  }
}
